import URL_E from '@/http/rh/employe';
import URL_O from '@/http/rh/employe-objectif';
import CONST from '@/constants/rh/employe';
export default {
  namespaced: true,
  state: {
    currentEmploye: null,
    currentObjectif: null,
    civilites: [],
    situationFamiliales: [],
    lienParentes: [],
    societes: [],
    edit: false,
    objectifStatuts: [
      { text: CONST.TXT_OBJ_ATTENTE, value: CONST.OBJ_ATTENTE },
      { text: CONST.TXT_OBJ_ATTEINT, value: CONST.OBJ_ATTEINT },
      { text: CONST.TXT_OBJ_NON_ATTEINT, value: CONST.OBJ_NON_ATTEINT },
    ],
  },

  getters: {
    currentEmploye: (state) => state.currentEmploye,
    currentObjectif: (state) => state.currentObjectif,
    civilites: (state) => state.civilites,
    societes: (state) => state.societes,
    situationFamiliales: (state) => state.situationFamiliales,
    lienParentes: (state) => state.lienParentes,
    edit: (state) => state.edit,
    objectifStatuts: (state) => state.objectifStatuts,
  },

  mutations: {
    SET_CURRENT_EMPLOYE(state, payload) {
      state.currentEmploye = payload;
    },

    SET_CURRENT_OBJECTIF(state, payload) {
      state.currentObjectif = payload;
    },

    SET_CIVILITES(state, payload) {
      state.civilites = payload;
    },

    SET_SOCIETES(state, payload) {
      state.societes = payload;
    },

    SET_SITUATION_FAMILIALES(state, payload) {
      state.situationFamiliales = payload;
    },

    SET_LIEN_PARENTES(state, payload) {
      state.lienParentes = payload;
    },
  },

  actions: {
    setEdit({ state }, edit) {
      state.edit = edit;
    },
    setCivilites({ commit }, payload) {
      commit('SET_CIVILITES', payload);
    },
    setSituationFamiliales({ commit }, payload) {
      commit('SET_SITUATION_FAMILIALES', payload);
    },
    setLienParentes({ commit }, payload) {
      commit('SET_LIEN_PARENTES', payload);
    },
    setSocietes({ commit }, payload) {
      commit('SET_SOCIETES', payload);
    },
    setCurrentEmploye({ commit }, payload) {
      commit('SET_CURRENT_EMPLOYE', payload);
    },
    setCurrentObjectif({ commit }, payload) {
      commit('SET_CURRENT_OBJECTIF', payload);
    },
    getEmploye({ commit }, payload) {
      commit('SET_CURRENT_EMPLOYE', null);

      if (payload.edit) {
        return window.axios
          .get(URL_E.EMPLOYE + '/' + payload.id, { params: { edit: true } })
          .then((resp) => {
            commit('SET_CURRENT_EMPLOYE', resp.data.employe);
          })
          .catch(() => {
            commit('SET_CURRENT_EMPLOYE', null);
          });
      } else {
        return window.axios
          .get(URL_E.EMPLOYE + '/' + payload.id)
          .then((resp) => {
            commit('SET_CURRENT_EMPLOYE', resp.data.employe);
          })
          .catch(() => {
            commit('SET_CURRENT_EMPLOYE', null);
          });
      }
    },

    getObjectif({ commit }, payload) {
      commit('SET_CURRENT_OBJECTIF', null);

      if (payload.edit) {
        return window.axios
          .get(URL_O.OBJECTIF + '/' + payload.id, { params: { edit: true } })
          .then((resp) => {
            commit('SET_CURRENT_OBJECTIF', resp.data.objectif);
          })
          .catch(() => {
            commit('SET_CURRENT_OBJECTIF', null);
          });
      } else {
        return window.axios
          .get(URL_O.OBJECTIF + '/' + payload.id)
          .then((resp) => {
            commit('SET_CURRENT_OBJECTIF', resp.data.objectif);
          })
          .catch(() => {
            commit('SET_CURRENT_OBJECTIF', null);
          });
      }
    },
  },
};
